export const CARE_PLAN_KEYS = {
  all: ['care-plan'] as const,
  list: () => [...CARE_PLAN_KEYS.all, 'list'] as const,
  byUser: (userid: string | number) => [...CARE_PLAN_KEYS.all, 'by-user', String(userid)] as const,
} as const;
